/**
 * LoadingScreen - Minimal full-screen loading state
 *
 * Features:
 * - Matches welcome page background exactly (pink / green / purple / blue soft blobs)
 * - Transparent W logo, centered, with soft pink glow
 */

import { useEffect } from 'react';

const LoadingScreen = ({ title = "Loading...", subtitle = "Please wait" }) => {
  // Set theme-color meta tag to match our soft background base
  useEffect(() => {
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (metaThemeColor) {
      metaThemeColor.setAttribute('content', '#fdf2f8');
    }
  }, []);

  return (
    <div
      className="fixed inset-0 flex items-center justify-center overflow-hidden"
      style={{
        background: `
          radial-gradient(circle at 0% 0%, rgba(233, 30, 140, 0.22) 0%, transparent 45%),
          radial-gradient(circle at 100% 0%, rgba(52, 211, 153, 0.22) 0%, transparent 40%),
          radial-gradient(circle at 50% 40%, rgba(139, 92, 246, 0.14) 0%, transparent 50%),
          radial-gradient(circle at 100% 70%, rgba(59, 130, 246, 0.20) 0%, transparent 50%),
          radial-gradient(circle at 0% 100%, rgba(236, 72, 153, 0.16) 0%, transparent 45%),
          linear-gradient(180deg, #fdf2f8 0%, #fef3f9 50%, #eff6ff 100%)
        `,
        paddingTop: 'env(safe-area-inset-top)',
        paddingBottom: 'env(safe-area-inset-bottom)',
        paddingLeft: 'env(safe-area-inset-left)',
        paddingRight: 'env(safe-area-inset-right)',
      }}
      data-testid="loading-screen"
    >
      <img
        src="/logotransparent.png"
        alt="Worthly"
        style={{
          width: '140px',
          height: '140px',
          objectFit: 'contain',
        }}
      />
    </div>
  );
};

export default LoadingScreen;
